const getAnswerTimeWidgets = (ctx) => {
  return {
    widgets: [
      {
        icon: "MessageCircleIcon",
        code: "successRate",
        name: ctx.$t("averageAnswerTime"),
        color: "warning",
        delimited: false,
        symbol: "",
        type: "answersTime",
        data: null
      }
    ],
    data: []
  }
}

export default getAnswerTimeWidgets